 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTNAV from '@/components/Text/nav'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTFLOW_0_0002 from '@/components/Text/Flow_0_0002'
 import TEXTPREFACE2015 from '@/components/Text/Preface2015'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTCHAPTER1 from '@/components/Text/Chapter1'
 import TEXTCHAPTER2 from '@/components/Text/Chapter2'
 import TEXTCHAPTER3 from '@/components/Text/Chapter3'
 import TEXTCHAPTER4 from '@/components/Text/Chapter4'
 import TEXTCHAPTER5 from '@/components/Text/Chapter5'
 import TEXTCHAPTER6 from '@/components/Text/Chapter6'
 import TEXTCHAPTER7 from '@/components/Text/Chapter7'
 import LOVE_2 from '@/components/love_2'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTAUTHOR from '@/components/Text/Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/nav",
 			"name" : "Text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/Flow_0_0002",
 			"name" : "Text/Flow_0_0002",
 			"component" : TEXTFLOW_0_0002
 		},
 		{
 			"path" : "/Text/Preface2015",
 			"name" : "Text/Preface2015",
 			"component" : TEXTPREFACE2015
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js